
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M11.5 11V1.5h37V11M15.75 55.5v4M44.25 55.5v4M8 11.6h44v43H8z"}}),_c('circle',{attrs:{"cx":"30","cy":"33.1","r":"14.5","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"18","cy":"6.58","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"35","cy":"6.58","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"42","cy":"6.58","r":"1.5","fill":"#241f21"}})])
          )
        }
      }
    